import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Tag, Button, Row, Col, Typography, Table, Spin, Divider, Space, Image, Tooltip } from 'antd'
import { EditOutlined, SwapOutlined } from '@ant-design/icons';
import { checkPermission } from '../../utils/permission';
import NumberFormat from 'react-number-format';
import ReactHtmlParser from 'react-html-parser'
import { isMobile } from 'react-device-detect';
import CashReceiptForm from './CashReceiptForm';
import CashReceiptUpdateStatusForm from './CashReceiptUpdateStatusForm';
import { ConvertCashReceiptStatus, ConvertPaymentMethod, ConvertReceiptType, isValidDate } from '../../utils/helpers';
import PrintButton from '../../components/PrintButton/PrintButton';
import PrintTable from './PrintTable';
import CustomerServiceConvertForm from '../customer-services/CustomerServiceConvertForm';
import { getSpecificService } from '../../redux/actions/CustomerServicesActions';

const { Paragraph, Text } = Typography;

class CashReceiptDetail extends Component {
    constructor() {
        super();
        this.state = {
            isOpenForm: false,
            isOpenStatusForm: false,
            isOpenConvertForm: false,
            currentData: null
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenForm(isOpenForm) {
        this.setState({ isOpenForm: isOpenForm });
    }

    toggleOpenUpdateStatusForm(isOpenStatusForm) {
        this.setState({ isOpenStatusForm: isOpenStatusForm });
    }

    reloadData() {
        if (this.props.from == 'customer_list') {
            this.props.reLoadCustomerCashReceiptList();
            this.props.reloadData();
        } else {
            this.props.reloadData();
        }
    }

    toggleOpenConvertForm(isOpenConvertForm, currentData = null) {
        this.setState({
            isOpenConvertForm: isOpenConvertForm,
            currentData: currentData
        });
    }

    onConvert(id) {
        this.props.getSpecificService(id).then(res => {
            this.toggleOpenConvertForm(true, res);
        })
    }

    render() {
        var { isOpenForm, isOpenStatusForm, currentData, isOpenConvertForm } = this.state;
        var { visible, currentItem, loadingDetail } = this.props;

        var columns = [
            {
                title: "STT",
                dataIndex: "stt",
                width: "40px",
                align: 'center',
                render: (text, record, index) => index + 1
            },
            // {
            //     title: "Sản phẩm/dịch vụ",
            //     dataIndex: "name",
            //     render: (text, record) => {
            //         const isTransferred = record.is_transferred;

            //         return (
            //             <div>
            //                 <div>{text}</div>
            //                 <Space size={[4, 4]} wrap className="mt-1">
            //                     {record.converted_from_service_name && (
            //                         <Tooltip title={`Được chuyển từ: ${record.converted_from_service_name}`}>
            //                             <Tag color="green">
            //                                 Được chuyển từ: {record.converted_from_service_name}
            //                             </Tag>
            //                         </Tooltip>
            //                     )}
            //                     {isTransferred && record.converted_to_service_name && (
            //                         <Tooltip title={`Đã chuyển sang: ${record.converted_to_service_name}`}>
            //                             <Tag color="red">
            //                                 Đã chuyển sang: {record.converted_to_service_name}
            //                             </Tag>
            //                         </Tooltip>
            //                     )}
            //                 </Space>
            //             </div>
            //         );
            //     }
            // },
            {
                title: "Sản phẩm/dịch vụ",
                dataIndex: "name",
                render: (text, record) => {
                    const isTransferred = record.is_transferred;
                    const from = record.converted_from_service_name;
                    const to = record.converted_to_service_name;

                    return (
                        <div>
                            <div>{text}</div>
                            {(from || (isTransferred && to)) && (
                                <Space size={[4, 4]} wrap className="mt-1">
                                    {from && (
                                        <Tooltip title={`Được chuyển từ: ${from}`}>
                                            <Tag color="green">Được chuyển từ: {from}</Tag>
                                        </Tooltip>
                                    )}
                                    {isTransferred && to && (
                                        <Tooltip title={`Đã chuyển sang: ${to}`}>
                                            <Tag color="red">Đã chuyển sang: {to}</Tag>
                                        </Tooltip>
                                    )}
                                </Space>
                            )}
                        </div>
                    );
                }
            },

            {
                title: "Loại",
                dataIndex: "type",
                width: '100px'
            },
            {
                title: "Số lượng",
                dataIndex: "quantity",
                width: '80px'
            },
            {
                title: "Đơn giá",
                dataIndex: "price",
                width: "120px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "Thành tiền",
                dataIndex: "amount",
                width: "120px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: '#',
                align: 'center',
                width: '150px',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => {
                    if (record.type === 'Sản phẩm') return null;
                    var isTransferred = record.is_transferred;
                    return checkPermission('customer_services', 'convert_to_service') && (
                        <Tooltip title="Chuyển đổi dịch vụ sang dịch vụ khác" placement="left">
                            <span
                                className={isTransferred ? 'disabled-action' : 'item-action-btn'}
                                onClick={!isTransferred ? () => this.onConvert(record.customer_service_id) : undefined}
                                style={{ cursor: isTransferred ? 'not-allowed' : 'pointer' }}
                            >
                                <SwapOutlined /> Chuyển đổi
                            </span>
                        </Tooltip>
                    );
                }
            }
        ];

        var columns_transfer = [
            {
                title: "STT",
                dataIndex: "stt",
                width: "40px",
                align: 'center',
                render: (text, record, index) => index + 1
            },
            {
                title: 'Mã phiếu',
                dataIndex: 'code',
                key: 'code',
                width: '80px'
            },
            {
                title: "Sản phẩm/dịch vụ",
                dataIndex: "name",
                render: (text, record) => {
                    const isTransferred = record.is_transferred;
                    const from = record.converted_from_service_name;
                    const to = record.converted_to_service_name;

                    return (
                        <div>
                            <div>{text}</div>
                            {(from || (isTransferred && to)) && (
                                <Space size={[4, 4]} wrap className="mt-1">
                                    {from && (
                                        <Tooltip title={`Được chuyển từ: ${from}`}>
                                            <Tag color="green">Được chuyển từ: {from}</Tag>
                                        </Tooltip>
                                    )}
                                    {isTransferred && to && (
                                        <Tooltip title={`Đã chuyển sang: ${to}`}>
                                            <Tag color="red">Đã chuyển sang: {to}</Tag>
                                        </Tooltip>
                                    )}
                                </Space>
                            )}
                        </div>
                    );
                }
            },
            {
                title: "Số lượng",
                dataIndex: "quantity",
                width: '80px'
            },
            {
                title: "Đơn giá",
                dataIndex: "price",
                width: "120px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "Thành tiền",
                dataIndex: "amount",
                width: "120px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "Số tiền chênh lệch",
                dataIndex: "amount", // hoặc null nếu không dùng field này
                width: "150px",
                render: (text, record) => {
                    const { amount_to_pay = 0, amount_to_deduct = 0 } = record;

                    if (amount_to_pay > 0) {
                        return (
                            <div style={{ color: 'green' }}>
                                + <NumberFormat value={amount_to_pay} displayType={'text'} thousandSeparator suffix="đ" />
                                <div style={{ fontSize: '12px' }}>Khách thanh toán thêm</div>
                            </div>
                        );
                    } else if (amount_to_deduct > 0) {
                        return (
                            <div style={{ color: 'red' }}>
                                - <NumberFormat value={amount_to_deduct} displayType={'text'} thousandSeparator suffix="đ" />
                                <div style={{ fontSize: '12px' }}>Hoàn lại cho khách</div>
                            </div>
                        );
                    }

                    return <span style={{ color: '#999' }}>Không chênh lệch</span>;
                }
            }

        ];

        const customer = {
            customer_name: currentItem?.customer_name,
            customer_phone: currentItem?.customer_phone,
            customer_address: currentItem?.customer_address,
            province_name: currentItem?.province_name,
            district_name: currentItem?.district_name,
            wards_name: currentItem?.wards_name,
            invoice_no: currentItem?.code,
            special_discount: currentItem?.special_discount,
            amount_paid: currentItem?.amount_paid,
            remaining_debt: currentItem?.remaining_debt,
            total_amount_paid: currentItem?.total_amount_paid,
        }

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Chi tiết phiếu thu: #${currentItem?.id}`}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '75%'}
                    extra={
                        <Space style={{ flexWrap: 'nowrap' }}>
                            {
                                checkPermission('cash_receipt', 'update') ? (
                                    <Button type="primary" onClick={() => this.toggleOpenForm(true)} icon={<EditOutlined />}>Sửa phiếu thu</Button>
                                ) : null
                            }
                            {/* {
                                checkPermission('cash_receipt', 'update_status') ? (
                                    <Button type="primary" onClick={() => this.toggleOpenUpdateStatusForm(true)} icon={<EditOutlined />}>Cập nhật trạng thái</Button>
                                ) : null
                            } */}
                            <PrintButton>
                                <PrintTable customer={customer} tableData={currentItem ? currentItem.items : []} />
                            </PrintButton>
                        </Space>
                    }
                >
                    {visible ? (
                        <div className='wrap-customer-detail'>
                            <Spin tip="Loading..." spinning={loadingDetail}>
                                <Row gutter={16}>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tên khách hàng">
                                                {currentItem?.customer_name}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Mã khách hàng">
                                                <Paragraph style={{ margin: 0 }} copyable={
                                                    {
                                                        text: currentItem?.customer_code,
                                                        tooltips: false
                                                    }
                                                }>
                                                    <Tag>{currentItem?.customer_code}</Tag>
                                                </Paragraph>
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Mã phiếu">
                                                {currentItem?.code}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Loại phiếu">
                                                {ConvertReceiptType(currentItem?.receipt_type ?? '')}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Số phiếu giấy">
                                                {currentItem?.paper_receipt_number}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tổng">
                                                <NumberFormat value={currentItem?.total_amount} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Ưu đãi">
                                                <NumberFormat value={currentItem?.special_discount} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Doanh số">
                                                <NumberFormat value={currentItem?.customer_revenue} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Số tiền thu">
                                                <NumberFormat value={currentItem?.amount_paid} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Tổng đã thu">
                                                <NumberFormat value={currentItem?.total_amount_paid} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Công nợ">
                                                <Tag color='red'><NumberFormat value={currentItem?.remaining_debt} displayType={'text'} suffix="đ" thousandSeparator={true} /></Tag>
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Trạng thái">
                                                {ConvertCashReceiptStatus(currentItem?.status)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Hình thức thu">
                                                {ConvertPaymentMethod(currentItem?.payment_method)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Ngày thu">
                                                {isValidDate(currentItem?.payment_at, false)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Người cập nhật">
                                                {currentItem?.updated_user}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Người tạo">
                                                {currentItem?.created_user}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Ngày tạo">
                                                {isValidDate(currentItem?.created_at)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <Descriptions size="small">
                                            <Descriptions.Item label="Ghi chú">
                                                {ReactHtmlParser(currentItem?.note)}
                                            </Descriptions.Item>
                                        </Descriptions>
                                        <Divider className='no-margin' />
                                    </Col>
                                    <Col xs={24} md={24}>
                                        <div className='mb-1 mt-2'>
                                            <Text strong>Ảnh phiếu</Text>
                                        </div>
                                        <Image.PreviewGroup>
                                            <Space wrap>
                                                {
                                                    currentItem?.images.map((item, index) => {
                                                        return (
                                                            <Image
                                                                key={index}
                                                                height={50}
                                                                width={50}
                                                                src={item.src}
                                                                style={{
                                                                    border: '1px solid #dedede',
                                                                    objectFit: 'cover',
                                                                    objectPosition: 'center',
                                                                }}
                                                            />
                                                        )
                                                    })
                                                }
                                            </Space>
                                        </Image.PreviewGroup>
                                    </Col>
                                </Row>
                                <Row gutter={16} className='mt-3'>
                                    <Col xs={24} md={24}>
                                        <Table
                                            className='mb-4'
                                            title={() => <strong style={{ marginLeft: '-8px' }}>Nội dung</strong>}
                                            size='small'
                                            rowKey='key'
                                            tableLayout="auto"
                                            columns={columns}
                                            locale={{ emptyText: "Chưa có dữ liệu" }}
                                            dataSource={currentItem ? currentItem.items : []}
                                            pagination={false}
                                        />
                                    </Col>
                                    {currentItem?.transfer_items?.length > 0 && (
                                        <Col xs={24} md={24}>
                                            <Table
                                                className='mb-4'
                                                title={() => <strong style={{ marginLeft: '-8px' }}>Phiếu chuyển đổi dịch vụ</strong>}
                                                size='small'
                                                rowKey='key'
                                                tableLayout="auto"
                                                columns={columns_transfer}
                                                locale={{ emptyText: "Chưa có dữ liệu" }}
                                                dataSource={currentItem ? currentItem.transfer_items : []}
                                                pagination={false}
                                            />
                                        </Col>
                                    )}
                                </Row>
                            </Spin>
                        </div>
                    ) : null}
                </Drawer>
                <CashReceiptForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <CashReceiptUpdateStatusForm
                    visible={isOpenStatusForm}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenUpdateStatusForm(false)}
                />
                <CustomerServiceConvertForm
                    visible={isOpenConvertForm}
                    currentData={currentData}
                    currentItem={currentItem}
                    reloadData={() => this.reloadData()}
                    onCancel={() => this.toggleOpenConvertForm(false)}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSpecificService: (id) => dispatch(getSpecificService(id))

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CashReceiptDetail' })(CashReceiptDetail));
